import { Button } from '@mdvip/shared/components/ui/button';
import { Separator } from '@mdvip/shared/components/ui/separator';
import { useToast } from '@mdvip/shared/hooks/use-toast';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddPaymentAccountModal } from '@/components/payments/accounts/AddPaymentAccountModal';
import type { PaymentTab } from '@/lib/payments/paymentAccount.types';

export function PaymentAccountsPage() {
  const { t } = useTranslation('members');
  const { toast } = useToast();
  const [modalState, setModalState] = useState<{ open: boolean; tab: PaymentTab }>({
    open: false,
    tab: 'credit-card',
  });

  const openModal = (tab: PaymentTab) => setModalState({ open: true, tab });

  const handleSuccess = () => {
    toast({
      title: t('payments.addAccount.successToast.title'),
      description: t('payments.addAccount.successToast.description'),
    });
    setModalState((state) => ({ ...state, open: false }));
  };

  return (
    <section>
      <h2 className="text-base font-semibold">{t('payments.pages.paymentAccounts.sectionTitle')}</h2>
      <p className="text-sm text-muted-foreground mt-1">{t('payments.pages.paymentAccounts.sectionDescription')}</p>

      <div className="mt-6 flex flex-col gap-9">
        {/* Account lists (rows, set-default, edit, remove) are CNP-132 — this ticket wires the add triggers only. */}
        <div>
          <h3 className="mb-3 text-lg font-semibold text-foreground">
            {t('payments.pages.paymentAccounts.creditCardsTitle')}
          </h3>
          <Separator className="mb-4" />
          <Button variant="outline" size="sm" onClick={() => openModal('credit-card')}>
            <Plus className="size-3.5" /> {t('payments.pages.paymentAccounts.addCard')}
          </Button>
        </div>

        <div>
          <h3 className="mb-3 text-lg font-semibold text-foreground">
            {t('payments.pages.paymentAccounts.bankAccountsTitle')}
          </h3>
          <Separator className="mb-4" />
          <Button variant="outline" size="sm" onClick={() => openModal('bank-account')}>
            <Plus className="size-3.5" /> {t('payments.pages.paymentAccounts.addBank')}
          </Button>
        </div>
      </div>

      <AddPaymentAccountModal
        open={modalState.open}
        onOpenChange={(open) => setModalState((state) => ({ ...state, open }))}
        defaultTab={modalState.tab}
        onSuccess={handleSuccess}
      />
    </section>
  );
}
